import classNames from "classnames";
import { useEffect, useState } from "react";

import EpisodeTracklist from "@/components/EpisodeTracklist";
import UpArrow from "@/icons/upArrow.svg";
import DownArrow from "@/icons/arrow-down-small.svg";

import { ListVisibilityEnum, TracklistInterface } from "../Tabs.interface";
import styles from "../Tabs.module.scss";

const Tracklist: React.FC<TracklistInterface> = ({
  tracklist,
  slug,
  className,
}) => {
  const heightOfTracklistItem = 65;
  const numberOfDisplayedItems = tracklist?.length >= 5 ? 5 : tracklist?.length;

  const [listHeight, setListHeight] = useState<number>(
    heightOfTracklistItem * numberOfDisplayedItems
  );
  const [listVisibility, setListVisibility] = useState<ListVisibilityEnum>(
    ListVisibilityEnum.Collapsed
  );

  const isTracklistButtonVisible = tracklist?.length > numberOfDisplayedItems;

  const toggleListVisibility = () => {
    const tracklistHeight = tracklist.length * heightOfTracklistItem;
    setListVisibility((prevState) => {
      if (prevState === ListVisibilityEnum.Collapsed) {
        setListHeight(tracklistHeight);
        return ListVisibilityEnum.Full;
      } else {
        window.scrollBy({
          top: -(
            tracklistHeight -
            heightOfTracklistItem * numberOfDisplayedItems
          ),
        });

        setListHeight(heightOfTracklistItem * numberOfDisplayedItems);
        return ListVisibilityEnum.Collapsed;
      }
    });
  };

  useEffect(() => {
    listVisibility === ListVisibilityEnum.Full && toggleListVisibility();
  }, [slug]);

  return (
    <div className={classNames(styles.tracklistContainer, className)}>
      <EpisodeTracklist
        tracklist={tracklist}
        className={classNames(styles.tracklist, styles[listVisibility])}
        style={{ height: listHeight }}
      />

      {isTracklistButtonVisible && (
        <button
          onClick={toggleListVisibility}
          className={styles.tracklistButton}
        >
          {listVisibility === ListVisibilityEnum.Collapsed ? (
            <>
              Rozwiń tracklistę {`(${tracklist?.length})`} <DownArrow />
            </>
          ) : (
            <>
              Zwiń tracklistę <UpArrow />
            </>
          )}
        </button>
      )}
    </div>
  );
};
export default Tracklist;
